
import React from 'react';
import { MessageSquare } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 text-center">
      <MessageSquare className="mx-auto h-12 w-12 text-gray-400 mb-3" />
      <p className="text-gray-600 mb-2">{t('interview.noTipsReceived')}</p>
      <p className="text-gray-500 text-sm">{t('interview.tipsFromSubmissions')}</p>
    </div>
  );
};

export default EmptyState;
